import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { Alert } from "@material-ui/lab";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import { useHistory } from "react-router-dom";
import GoToBackButton from "../../../elements/goToBack/GoToBack";
import { TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledBlockLabel, StyledFormBlock, StyledFormGrid, StyledInputBlock } from "../../../styles/styledTabsForm";
import { StyledFeeDetailsWrapper } from "../../../fee/styledFee";
import RatesEditForm from "../../../rates/admin/RatesEditForm";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";

const RateDetailsContainer = ({ match }) => {
  const { t } = useTranslation("clientsPage");
  const [rate, setRate] = useState();
  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    axios.get("/api/rates/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setRate(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, []);

  if (!rate) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (rate.length === 0) {
    return <Alert severity="warning">{t("details.rate.edit.form.emptyData")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("details.rate.edit.title")} {rate.rateBase.currency.asset}/{rate.connection.service.name} • eXsoft.io</title>
        </Helmet>
        <StyledFeeDetailsWrapper>
          <GoToBackButton
            handler={() => {history.goBack();}}
            pt="20"
            pb="30"
          />
          <StyledFormGrid>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("details.rate.edit.form.rate")}
              </StyledBlockLabel>
              <StyledInputBlock>
                <TextField
                  className="grid-form__input"
                  label={t("details.rate.edit.form.currency")}
                  type="text"
                  value={rate.rateBase.currency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.rate.edit.form.service")}
                  type="text"
                  value={getServiceNameWithNickname(rate.connection.service.name, rate.connection.service.nickname)}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.rate.edit.form.rateBaseSelling")}
                  type="text"
                  value={rate.rateBase.selling}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.rate.edit.form.rateBasePurchase")}
                  type="text"
                  value={rate.rateBase.purchase}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.rate.edit.form.selling")}
                  type="text"
                  value={rate.selling}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.rate.edit.form.purchase")}
                  type="text"
                  value={rate.purchase}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("details.rate.edit.form.adjustment")}
              </StyledBlockLabel>
              <RatesEditForm
                rate={rate}
                setRate={setRate}
                notification={notification}
                setNotification={setNotification}
                url="/api/rates/"
              />
              <div className="clear-column" />
            </StyledFormBlock>
          </StyledFormGrid>
        </StyledFeeDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default RateDetailsContainer;